import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const TwitterIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M25.5391 2.89038C24.6049 3.30169 23.6152 3.5732 22.6019 3.69615C23.6688 3.05491 24.4676 2.0493 24.8508 0.865025C23.862 1.44206 22.7662 1.86211 21.5996 2.09604C20.83 1.27304 19.8102 0.727182 18.6985 0.543237C17.5868 0.359292 16.4455 0.547551 15.4518 1.07878C14.4581 1.61001 13.6675 2.45448 13.203 3.48106C12.7385 4.50764 12.6259 5.65888 12.8827 6.75601C8.63031 6.55535 4.86137 4.51336 2.33903 1.42647C1.88031 2.20606 1.64104 3.09523 1.64659 3.99975C1.64659 5.77765 2.55113 7.34033 3.92147 8.25839C3.10931 8.23254 2.31509 8.01295 1.605 7.61793V7.68135C1.60454 8.86287 2.01284 10.0082 2.76064 10.9229C3.50844 11.8377 4.54967 12.4655 5.70769 12.7C4.95733 12.9011 4.17143 12.9313 3.40785 12.7884C3.73666 13.8052 4.3746 14.694 5.2327 15.3308C6.09079 15.9677 7.12626 16.3209 8.19467 16.3411C6.38505 17.7612 4.15069 18.532 1.85037 18.5297C1.44488 18.5297 1.04044 18.5058 0.633911 18.46C2.97919 19.9617 5.70614 20.7588 8.49099 20.7567C17.9045 20.7567 23.0459 12.9631 23.0459 6.21537C23.0459 5.99807 23.0459 5.77869 23.0303 5.56035C24.0346 4.83759 24.9009 3.94028 25.588 2.91117L25.5391 2.89038Z"
    />
  </svg>
);

TwitterIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

TwitterIcon.defaultProps = {
  fillOpacity: 1,
  ...helpers.getDefaultIconDimensionsProps(26, 21),
};

export default TwitterIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/twitter.js